import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { CustomPageConfigurationType } from '../../../../../../api/custom-pages.dao';
import { ConfPassNavPresentation } from './conf-passport-nav-form.presentation';
import ConfPassNavFormVM from './conf-passport-nav-form.viewmodel';

export interface IConfPassNavContainerProps {
    accountId: number;
    eventId: number;
    subdomain: string;
    setIsResetCustomPages: () => void;
    onSuccess: (pages: CustomPageConfigurationType[]) => void;
}

const ConfPassNavFormContainer = withViewModel(ConfPassNavPresentation, async (props: IConfPassNavContainerProps) => {
    const { accountId, eventId, setIsResetCustomPages, onSuccess } = props;
    const confPassNavFormVM = new ConfPassNavFormVM(accountId, eventId, setIsResetCustomPages, onSuccess);
    await confPassNavFormVM.initialize();
    return confPassNavFormVM;
});

export { ConfPassNavFormContainer as ConfPassNavForm };